import PropTypes from 'prop-types';
import './taglabel.css';

const TagLabel = ({ label, variant, isNew }) => {
  let className = 'taglabel';

  if (variant === 'design') {
    className += ' tag-design';
  } else if (variant === 'learn') {
    className += ' tag-learn';
  } else if (variant === 'assess') {
    className += ' tag-assess';
  } else if (variant === 'comingSoon') {
    className += ' coming-soon';
  } 
  
  if (isNew) {
    className += ' tag-new';
  }


  return (
    <span className={className}>
      {label}
    </span>
  );
};

TagLabel.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['design', 'learn', 'assess', 'comingSoon', 'new']),
};

export default TagLabel;
